/* eslint-disable no-useless-escape */
import React from 'react'
import { FormComponentProps } from 'antd/lib/form'
import { Button, Col, Input, Row, Select, Form } from 'antd'
import { locationHierarchyOption, siteHierarchyOption } from '../model'

interface Params {
    dataSite: siteHierarchyOption[]
    dataLocation: locationHierarchyOption[]
    optionLocation: locationHierarchyOption[]
    selectSite: Function
    selectLocation: Function
    isDisableLocation: boolean
    isDisableBuilding: boolean
    onCancel: Function
}

type Props = Params & FormComponentProps
const { Option } = Select
const RenderBuildingTab: React.FC<Props> = (props: Props) => {
    const { getFieldDecorator, getFieldValue, resetFields } = props.form

    const validateBuilding = (_: any, value: any, callback) => {
        const pattern = /^[A-Za-z0-9ก-๙]{1}/
        const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
        // eslint-disable-next-line no-useless-escape
        if (value) {
            if (pattern.test(value.replace(/ +/g, '').trim())) {
                const filterLocation = props.dataLocation.filter(data => data.locationName === getFieldValue('locationBuilding')).flatMap(data => data.buildings)
                const isDuplicate = filterLocation.some((it) => it.buildingName.toLowerCase().trim() === value.toLowerCase().trim())
                if (isDuplicate) {
                    callback('Building Name already exists. It must be unique. Please try another one.')
                } else {
                    callback()
                }
            } else {
                if (format.test(value.replace(/ +/g, '').trim())) {
                    callback(`Field Label can't contain any of the following characters ${format}`)
                }
                callback('Default value is not a valid')
            }

        } else {
            callback()
        }
    }

    const handleSelectSite = (site: string) => {
        props.selectSite(site)
    }

    const handleSelectLocation = (location: string) => {
        props.selectLocation(location, getFieldValue('siteBuilding'))
    }

    const handleCancel = () => {
        props.onCancel()
    }

    const handleChangeSite = () => {
        resetFields(['locationBuilding', 'building'])
    }

    const handleChangeLocation = () => {
        resetFields(['building'])
    }

    return (
        <Row gutter={[10, 10]}>
            <Col span={6} md={6} sm={24}>
                <Form.Item label={'Site Name'}>
                    {getFieldDecorator('siteBuilding',
                        {
                            rules: [{ required:  true , message: 'Site Name is required' }]
                        })(
                            <Select placeholder="Site Name" onSelect={handleSelectSite} onChange={handleChangeSite} allowClear>
                                {props.dataSite.map((it, index) => {
                                    return (<Option value={it.siteName} key={index}>{it.siteName}</Option>)
                                })}
                            </Select>
                        )}
                </Form.Item>
            </Col>
            <Col span={6} md={6}>
                <Form.Item label={'Location Name'}>
                    {getFieldDecorator('locationBuilding',
                        {
                            rules: [{ required: true, message: 'Location Name is required' }]
                        })(
                            <Select placeholder="Location Name" disabled={props.isDisableLocation} onSelect={handleSelectLocation} onChange={handleChangeLocation} allowClear>
                                {props.optionLocation.map((it, index) => {
                                    return (<Option value={it.locationName} key={index}>{it.locationName}</Option>)
                                })}
                            </Select>
                        )}
                </Form.Item>
            </Col>
            <Col span={6} md={6}>
                <Form.Item label={'Building Name'}>
                    {getFieldDecorator('building',
                        {
                            rules: [
                                { required: true, message: 'Building Name is required' },
                                { validator: validateBuilding }
                            ]
                        })(
                            <Input placeholder={'Building Name'} disabled={props.isDisableBuilding} allowClear />
                        )}
                </Form.Item>
            </Col>
            <Col span={3} lg={3} md={3} sm={24} xs={24}>
                <Form.Item style={{ marginTop: 40 }}>
                    <Button type="default" style={{ width: '-webkit-fill-available' }} htmlType="reset" onClick={handleCancel}>Cancel</Button>
                </Form.Item>
            </Col>
            <Col span={3} lg={3} md={3} sm={24} xs={24}>
                <Form.Item style={{ marginTop: 40 }}>
                    <Button className="addCriteriaButton" style={{ width: '-webkit-fill-available' }}
                        htmlType="submit">Submit</Button>
                </Form.Item>
            </Col>
        </Row>
    )
}

export default RenderBuildingTab
